export default __webpack_public_path__ + "static/media/OSMOS_CENERE_120x120_OSMOS RUGGINE_60x120.395eb018.jpg";